(function () {
  function initImmersion(track) {
    var slides = Array.prototype.slice.call(track.querySelectorAll('.luxe-immersion__slide'));
    if (slides.length < 1) return;
    var section = track.closest('.luxe-immersion');
    var prev = section ? section.querySelector('[data-prev]') : null;
    var next = section ? section.querySelector('[data-next]') : null;
    var idx = 0;
    var timer = null;

    function go(i) {
      idx = (i + slides.length) % slides.length;
      // Scroll the track's own horizontal position — never the page.
      track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
    }
    if (next) next.addEventListener('click', function () { go(idx + 1); restart(); });
    if (prev) prev.addEventListener('click', function () { go(idx - 1); restart(); });

    // keep idx in sync if the user manually scrolls/swipes
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var nearest = 0, best = Infinity, mid = track.scrollLeft + track.clientWidth / 2;
        slides.forEach(function (s, i) {
          var c = s.offsetLeft + s.offsetWidth / 2;
          var d = Math.abs(c - mid);
          if (d < best) { best = d; nearest = i; }
        });
        idx = nearest;
      }, 120);
    });

    var auto = parseInt(track.getAttribute('data-autoplay'), 10);
    var onScreen = true;
    function start() { if (auto && slides.length > 1 && onScreen && !timer) timer = setInterval(function () { go(idx + 1); }, auto * 1000); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }
    if (section) { section.addEventListener('mouseenter', stop); section.addEventListener('mouseleave', start); }

    // Only run autoplay while the carousel is actually visible.
    if (section && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        onScreen = entries[0].isIntersecting;
        if (onScreen) start(); else stop();
      }, { threshold: 0.35 }).observe(section);
    }

    start();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-immersion]'), initImmersion);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
